// extracted by mini-css-extract-plugin
export var primitiveLabel = "_tn-0";